import React,{useEffect, useState} from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import { Container, Row, Col, Card } from "react-bootstrap";
import { getAllPartners } from "../../Action/action";
import config from "../../config/config";

export default function Partnership() {
  const [partnerForm, setPartnerForm] = useState([]);

  useEffect(() => {
    getAllPartnersList();
  }, []);

  const getAllPartnersList = async () => {
    try {
      let result = await getAllPartners();
      console.log('FORM result', result);
      if (result.success) {
        setPartnerForm(result.data);
      }
    } catch (error) {
      console.log(error);
    }
  }
  return (
    <>
      <Header />
      <div className="bg-darkgrey">
        <section className="ourteam py-5">
          <Container>
            <Row>
              <Col lg={12} className="mb-4">
                <div className="">
                  <h1 className="text-white mb-3">Our Partners</h1>
                  <p className="text-light-grey2"></p>
                </div>
              </Col>
              <Col lg={12}>
                <Row>
                {partnerForm && partnerForm.length > 0 ? (
                partnerForm.filter((item) => item.is_visible === 1).map((item, index) => (
                  <Col key={index} lg={4} className="mb-4">
                    <div className="cardStyle3">
                      <Card className="p-4">
                        <div className="pictureFrame">
                          <Card.Img
                            variant="top"
                            src={`${config.imagePath}${item.profilePic}`}
                            className="mb-3"
                          />
                        </div>
                        <Card.Body className="p-0">
                          <div>
                            <h4 className="text-white">{item.name}</h4>
                            <h5 className="fw-normal text-light-grey2">{item.position}</h5>
                            <p className="text-light-grey2">{item.description}</p>
                            <div className="social-Icon">
                              <ul className="list-unstyled ps-0 mb-0">
                                {(() => {
                                          let socials = [];

                                          try {
                                            socials = JSON.parse(
                                              item?.social_accounts
                                            );
                                          } catch (error) {
                                            console.error(
                                              "Error parsing social accounts:",
                                              error
                                            );
                                          }

                                          const socialStyles = {
                                            twitter: {
                                              icon: "fab fa-x-twitter",
                                              color: "#000000",
                                            },
                                            facebook: {
                                              icon: "fab fa-facebook",
                                              color: "#1877F2",
                                            },
                                            instagram: {
                                              icon: "fab fa-instagram",
                                              color: "#E1306C",
                                            },
                                            linkedin: {
                                              icon: "fab fa-linkedin",
                                              color: "#0077B5",
                                            },
                                            github: {
                                              icon: "fab fa-github",
                                              color: "#333",
                                            },
                                            telegram: {
                                              icon: "fab fa-telegram",
                                              color: "#0088cc",
                                            },
                                            discord: {
                                              icon: "fab fa-discord",
                                              color: "#5865F2",
                                            },
                                            youtube: {
                                              icon: "fab fa-youtube",
                                              color: "#FF0000",
                                            },
                                          };

                                          return Array.isArray(socials) &&
                                            socials.length > 0 ? (
                                            socials.map((social, index) => {
                                              const socialData = socialStyles[
                                                social.name.toLowerCase()
                                              ] || {
                                                icon: "fas fa-link",
                                                color: "#fff",
                                              };

                                              return (
                                                <a
                                                  key={index}
                                                  href={social.link}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  className="text-decoration-none"
                                                >
                                                  <i
                                                    className={`${socialData.icon} fs-3`}
                                                    style={{
                                                      color: socialData.color,
                                                    }}
                                                  ></i>
                                                </a>
                                              );
                                            })
                                          ) : (
                                            <span className="text-muted">
                                              No social accounts available
                                            </span>
                                          );
                                        })()}
                              </ul>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                  </Col>)))
                  :
                  ("")}
            </Row>
            </Col>
          </Row>
          </Container>
        </section>
      </div>
      <Footer />
    </>
  );
}